<template>
  <div class="te-bg-lp">
    <TeBotchan />
    <div class="mx-auto max-w-[560px]">
      <!-- カバー -->
      <section
        id="cover"
        class="te-bg-branded-cover relative mx-auto px-5 pt-5 sm:px-14 sm:pt-7"
      >
        <h1 class="mb-8">
          <img
            class="te-branded-catch-img w-full"
            src="~/assets/images/Te/TeLp/Branded/Index/cover-catch.svg"
            alt="未経験からWebデザイナーへ仕事の獲得までをプロが徹底サポート"
            width="308"
            height="212"
          >
        </h1>
        <a
          class="bot_open mt-5 block w-full text-center"
          href="/counseling/htmlcss-schedule#schedule"
        >
          <img
            class="te-cover-btn te-btn-hover mx-auto w-full"
            src="~/assets/images/Te/TeLp/Branded/Index/cv-btn.webp"
            alt="無料で相談してみる"
            width="267"
            height="72"
          >
        </a>
        <div class="co-display-14 te-cover-caution mb-2 mt-3 text-center text-co-gray-500">
          ※無理な勧誘は一切ありません
        </div>
        <div class="text-center">
          <img
            class="te-cover-badge-img mx-auto w-full"
            src="~/assets/images/Te/TeLp/Branded/Index/cover-badge.svg"
            alt="受講満足度75%、5万円分の副業案件保証、受講者数10万人以上"
            width="309"
            height="113"
          >
        </div>
      </section>

      <!-- リリスキル補助金 -->
      <section>
        <div class="te-bg-reskill px-4 py-5 sm:px-14">
          <img
            class="mb-2 w-full"
            src="~/assets/images/Te/TeLp/Branded/Index/reskilling-banner.svg"
            alt="受講料最大70%OFF"
            width="343"
            height="61"
          >
          <div class="co-display-14 text-left text-co-gray-600">
            <span>テックアカデミーのコースは</span>
            <b>経済産業省のリスキリングを通じたキャリアアップ支援事業に認定</b>
            <span>され、条件を満たすことで</span>
            <b>受講料の最大70%</b>
            <span>が還元されます。詳細は無料相談でご案内いたします。</span>
          </div>
        </div>
      </section>

      <!-- 事例 -->
      <section class="bg-co-gray-50 py-10">
        <h2 class="mb-8 px-4 text-center sm:px-10">
          <img
            class="te-lp-branded-h2-title mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/h2-example.svg"
            alt="エンジニア・Webデザイナーの夢を叶えた受講生"
            width="339"
            height="106"
            loading="lazy"
          >
        </h2>
        <TeLpBrandedExample />
      </section>

      <!-- 不安 -->
      <section class="te-bg-webdesing-aff-anxiety">
        <img
          class="mx-auto w-full"
          src="~/assets/images/Te/TeLp/Branded/Index/bg-top-anxiety.webp"
          alt="イラスト"
          width="375"
          height="30"
        >
        <h2 class="mb-4 pt-10 text-center">
          <img
            class="te-lp-branded-h2-title mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/h2-anxety.svg"
            alt="こんな不安で悩んでませんか？"
            width="335"
            height="94"
            loading="lazy"
          >
        </h2>
        <div class="co-display-13 mb-8 text-center text-co-gray-500">
          プログラミングやWebデザインを独学した方が、
          <br>
          挫折してしまう主な理由は以下の3つです。
        </div>
        <div class="mb-5 text-center">
          <img
            class="mx-auto w-full"
            src="~/assets/images/Te/TeLp/Branded/Index/anxiety-img.webp"
            alt="学ぶべきスキルが何かがわからない、わからないことを聞ける人がいない、モチベーションが続かない"
            width="375"
            height="310"
            loading="lazy"
          >
        </div>
        <div class="te-bg-lp-section text-center">
          <img
            class="mx-auto w-full"
            src="~/assets/images/Te/TeLp/Branded/Index/anxiety-triangle.svg"
            alt="飾り"
            width="375"
            height="45"
            loading="lazy"
          >
        </div>
      </section>

      <!-- メッセージ -->
      <section class="te-bg-lp-section pt-5">
        <div class="mb-5 text-center">
          <img
            class="te-lp-branded-img mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/answer-title-eyecatch.svg"
            alt="テックアカデミーなら挫折させない"
            width="320"
            height="101"
            loading="lazy"
          >
        </div>
        <div class="text-center">
          <img
            class="mx-auto w-full"
            src="~/assets/images/Te/TeLp/Branded/Index/answer-img.webp"
            alt="未経験からの学びに最適な学習環境をご用意しています"
            width="375"
            height="252"
            loading="lazy"
          >
        </div>
      </section>

      <!-- 4つの強み -->
      <section class="bg-co-gray-50 pb-10 pt-8">
        <h2 class="text-center">
          <img
            class="te-lp-branded-h2-title mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/h2-features.svg"
            alt="テックアカデミー４つの強み"
            width="223"
            height="111"
            loading="lazy"
          >
        </h2>
        <div class="te-branded-feature-content mb-10 text-center">
          <img
            class="mx-auto w-full"
            src="~/assets/images/Te/TeLp/Branded/Index/features-contents.webp"
            alt="1.未経験の方に最適なコース、2.万全な学習サポート、3.安心のキャリアサポート、4.転職サポート"
            width="375"
            height="1330"
            loading="lazy"
          >
        </div>
        <div class="px-7 text-center">
          <img
            class="te-lp-branded-img mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/features-message.webp"
            alt="他のスクールや独学では得られないテックアカデミー独自のサポートで未経験からでも安心確実に叶えることができます"
            width="315"
            height="216"
            loading="lazy"
          >
        </div>
      </section>

      <!-- CTA -->
      <section class="te-bg-cta px-7 py-6 sm:py-10">
        <h2 class="mb-5 text-center">
          <img
            class="te-lp-branded-h2-title mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/h2-cta-title.svg"
            alt="まずは気軽に無料相談"
            width="240"
            height="94"
            loading="lazy"
          >
        </h2>
        <div class="mb-2 text-center">
          <img
            class="mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/cta-eyecatch.svg"
            alt="こんなことも聞ける"
            width="144"
            height="38"
            loading="lazy"
          >
        </div>
        <div class="mb-5 text-center sm:mb-10">
          <img
            class="te-branded-cta-list mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/cta-list.svg"
            alt="未経験からの最適な学習方法のご案内、カリキュラムの詳細についてのご案内、キャリアサポートの内容をご案内、5万円分の副業案件保証制度のご案内"
            width="319"
            height="172"
            loading="lazy"
          >
        </div>
        <a
          class="bot_open mb-3 block w-full text-center"
          href="/counseling/htmlcss-schedule#schedule"
        >
          <img
            class="te-branded-lp-cta te- mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/cv-btn.webp"
            alt="無料で相談してみる"
            width="267"
            height="72"
          >
        </a>
        <div class="co-display-14 mt-3 text-center text-co-gray-500">
          ※無理な勧誘は一切ありません
        </div>
      </section>

      <!-- 人気5コース -->
      <section class="bg-co-gray-50 py-10">
        <h2 class="mb-8 px-4 text-center sm:px-10">
          <img
            class="te-lp-branded-h2-title mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/h2-course.svg"
            alt="あなたの理想を実現できる人気5コース"
            width="311"
            height="107"
            loading="lazy"
          >
        </h2>
        <div class="text-center">
          <img
            class="mx-auto mb-12 w-full"
            src="~/assets/images/Te/TeLp/Branded/Index/course-web-engineer.webp"
            alt="Webエンジニア転職保証コース"
            width="430"
            height="442"
          >
          <img
            class="mx-auto mb-7 w-full"
            src="~/assets/images/Te/TeLp/Branded/Index/course-order-made.webp"
            alt="オーダーメイドコース"
            width="430"
            height="396"
          >
          <div class="mb-12 flex items-center justify-center gap-2">
            <img
              src="~/assets/images/Te/TeLp/Branded/Index/course-illust-woman.svg"
              alt="イラスト"
              width="50"
              height="50"
              class="te-order-cta-ilust"
            >
            <div class="text-center">
              <div class="te-order-cta-title mb-2 font-bold text-co-gray-600">
                あなた専用の学習計画について相談できます
              </div>
              <a
                href="/counseling/htmlcss-schedule#schedule"
                class="bot_open te-cta-sub-btn inline-block px-3 py-2 font-bold"
              >
                お気軽にご利用ください
                <FontAwesomeIcon
                  :icon="faChevronRight"
                  class="fa-fw co-display-13"
                />
              </a>
            </div>
          </div>
          <img
            class="mx-auto mb-12 w-full"
            src="~/assets/images/Te/TeLp/Branded/Index/course-first-sidejob.webp"
            alt="はじめての副業コース"
            width="430"
            height="396"
          >
          <img
            class="mx-auto w-full"
            src="~/assets/images/Te/TeLp/Branded/Index/course-webdesign.webp"
            alt="Webデザインコース"
            width="430"
            height="396"
          >
        </div>
      </section>

      <!-- リスキル補助金 -->
      <section class="te-bg-reskill px-4 py-5 text-center sm:px-14">
        <img
          class="mx-auto w-full"
          src="~/assets/images/Te/TeLp/Branded/Index/reskilling-banner.svg"
          alt="受講料最大70%OFF"
          width="343"
          height="61"
        >
      </section>

      <!-- CTA -->
      <section class="te-bg-cta px-7 py-6 sm:py-10">
        <div class="mb-8 text-center">
          <img
            class="te-lp-branded-img mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/cta-course-content.svg"
            alt="コース選びについてご相談ください"
            width="319"
            height="319"
            loading="lazy"
          >
        </div>
        <a
          class="bot_open mb-3 block w-full text-center"
          href="/counseling/htmlcss-schedule#schedule"
        >
          <img
            class="te-branded-lp-cta te-btn-hover mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/cv-btn.webp"
            alt="無料で相談してみる"
            width="267"
            height="72"
          >
        </a>
        <div class="co-display-14 mb-8 mt-3 text-center text-co-gray-500">
          ※無理な勧誘は一切ありません
        </div>
        <div class="mb-2 text-center">
          <img
            class="mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/cta-eyecatch.svg"
            alt="こんなことも聞ける"
            width="144"
            height="38"
            loading="lazy"
          >
        </div>
        <div class="text-center">
          <img
            class="te-branded-cta-list mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/cta-list.svg"
            alt="未経験からの最適な学習方法のご案内、カリキュラムの詳細についてのご案内、キャリアサポートの内容をご案内、5万円分の副業案件保証制度のご案内"
            width="319"
            height="172"
            loading="lazy"
          >
        </div>
      </section>

      <!-- 他スクールとの比較 -->
      <section class="bg-co-gray-50 px-4 py-10 sm:px-14">
        <h2 class="mb-8 px-4 text-center sm:px-10">
          <img
            class="te-lp-branded-h2-title mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/h2-comparison.svg"
            alt="他スクールとの比較"
            width="288"
            height="80"
            loading="lazy"
          >
        </h2>
        <div class="text-center">
          <img
            class="mx-auto w-full"
            src="~/assets/images/Te/TeLp/Branded/Index/comparison-table.svg"
            alt="比較表"
            width="343"
            height="485"
            loading="lazy"
          >
        </div>
      </section>

      <!-- FAQ -->
      <section class="bg-co-gray-50 px-7 py-10">
        <h2 class="mb-8 px-4 text-center sm:px-10">
          <img
            class="te-lp-branded-h2-title mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/h2-faq.svg"
            alt="よくある質問"
            width="192"
            height="80"
            loading="lazy"
          >
        </h2>
        <!-- QA1 -->
        <div class="mb-8">
          <div class="mb-3 flex items-center">
            <img
              class="mr-3"
              src="~/assets/images/Te/TeLp/Branded/Index/icon-q.svg"
              alt="Q"
              width="32"
              height="32"
              loading="lazy"
            >
            <span class="co-display-11 font-bold text-co-gray-600">
              受講に必要なものはなんですか？
            </span>
          </div>
          <div class="flex items-start">
            <img
              class="mr-3"
              src="~/assets/images/Te/TeLp/Branded/Index/icon-a.svg"
              alt="A"
              width="32"
              height="32"
              loading="lazy"
            >
            <span class="co-display-11 te-text-branded font-bold">
              パソコンとインターネットの環境があれば、どなた様もご受講いただけます。
            </span>
          </div>
        </div>
        <!-- QA2 -->
        <div class="mb-8">
          <div class="mb-3 flex items-center">
            <img
              class="mr-3"
              src="~/assets/images/Te/TeLp/Branded/Index/icon-q.svg"
              alt="Q"
              width="32"
              height="32"
              loading="lazy"
            >
            <span class="co-display-11 font-bold text-co-gray-600">
              初心者ですができますか？
            </span>
          </div>
          <div class="flex items-start">
            <img
              class="mr-3"
              src="~/assets/images/Te/TeLp/Branded/Index/icon-a.svg"
              alt="A"
              width="32"
              height="32"
              loading="lazy"
            >
            <span class="co-display-11 te-text-branded font-bold">
              問題なくご受講いただけます。受講される方の9割以上が未経験の方です。テックアカデミーでは10万人の受講生をサポートしてきた実績がございます。安心してご利用ください。
            </span>
          </div>
        </div>
        <!-- QA3 -->
        <div class="mb-8">
          <div class="mb-3 flex items-start">
            <img
              class="mr-3"
              src="~/assets/images/Te/TeLp/Branded/Index/icon-q.svg"
              alt="Q"
              width="32"
              height="32"
              loading="lazy"
            >
            <span class="co-display-11 font-bold text-co-gray-600">
              学習と仕事を両立できるか不安なのですが、大丈夫ですか？
            </span>
          </div>
          <div class="flex items-start">
            <img
              class="mr-3"
              src="~/assets/images/Te/TeLp/Branded/Index/icon-a.svg"
              alt="A"
              width="32"
              height="32"
              loading="lazy"
            >
            <span class="co-display-11 te-text-branded font-bold">
              問題なくご受講いただけます。カリキュラムは移動中などの隙間時間でもご利用いただけますし、講師の対応は23時まで行っております。また、受講開始のタイミングで学習のペースを講師と相談できますので、ライフスタイルに合わせたご学習が可能となっております。
            </span>
          </div>
        </div>
        <!-- QA4 -->
        <div class="mb-8">
          <div class="mb-3 flex items-center">
            <img
              class="mr-3"
              src="~/assets/images/Te/TeLp/Branded/Index/icon-q.svg"
              alt="Q"
              width="32"
              height="32"
              loading="lazy"
            >
            <span class="co-display-11 font-bold text-co-gray-600">
              本当に副業できるようになりますか？
            </span>
          </div>
          <div class="flex items-start">
            <img
              class="mr-3"
              src="~/assets/images/Te/TeLp/Branded/Index/icon-a.svg"
              alt="A"
              width="32"
              height="32"
              loading="lazy"
            >
            <span class="co-display-11 te-text-branded font-bold">
              問題なく副業ができるようになります。テックアカデミーが独自に抱えているWeb制作案件を提供いたします。5万円分の副業案件を確実にご案内する保証制度もございます。副業サポートを受ける際には決められた学習を全て終わらせていただく条件がございますので、無料相談にてご確認ください。
            </span>
          </div>
        </div>
        <!-- QA5 -->
        <div>
          <div class="mb-3 flex items-center">
            <img
              class="mr-3"
              src="~/assets/images/Te/TeLp/Branded/Index/icon-q.svg"
              alt="Q"
              width="32"
              height="32"
              loading="lazy"
            >
            <span class="co-display-11 font-bold text-co-gray-600">
              他のサービスとの違いは何ですか？
            </span>
          </div>
          <div class="flex items-start">
            <img
              class="mr-3"
              src="~/assets/images/Te/TeLp/Branded/Index/icon-a.svg"
              alt="A"
              width="32"
              height="32"
              loading="lazy"
            >
            <span class="co-display-11 te-text-branded font-bold">
              学習面においては、サービス開始から12年間で10万人を超える受講実績があり、未経験の方のスキルアップのためのサポートを徹底して磨いてきました。また卒業後のサポートとして、副業案件の提供保証、転職サポートを提供しており、受講される方の結果にコミットしている部分が他のサービスとは大きく違っています。
            </span>
          </div>
        </div>
      </section>


      <!-- 無料相談の声 -->
      <section class="bg-co-gray-50 py-10">
        <h2 class="mb-8 px-4 text-center sm:px-10">
          <img
            class="te-lp-branded-h2-title mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/h2-reaction.svg"
            alt="無料相談 受けてみてよかった人の声続出"
            width="343"
            height="105"
            loading="lazy"
          >
        </h2>
        <TeLpBrandedReaction />
      </section>

      <!-- CTA -->
      <section
        id="bottom"
        class="te-bg-cta px-5 py-6 sm:py-10"
      >
        <h2 class="mb-3 text-center sm:mb-7">
          <img
            class="te-lp-branded-h2-title mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/h2-cta-title.svg"
            alt="まずは気軽に無料相談"
            width="240"
            height="94"
            loading="lazy"
          >
        </h2>
        <div class="mb-8 text-center">
          <img
            class="te-branded-cta-list mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/cta-photo.webp"
            alt="無料相談でWebデザイナーへの一歩を踏み出しませんか？"
            width="335"
            height="193"
            loading="lazy"
          >
        </div>
        <div class="mb-2 text-center">
          <img
            class="mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/cta-eyecatch.svg"
            alt="こんなことも聞ける"
            width="144"
            height="38"
            loading="lazy"
          >
        </div>
        <div class="mb-5 text-center sm:mb-10">
          <img
            class="te-branded-cta-list mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/cta-list.svg"
            alt="他のスクールとの違いを詳しくご案内、カリキュラムの詳細についてご案内、学習サポートや副業サポートのご案内、学習サポートや副業サポートのご案内"
            width="319"
            height="172"
            loading="lazy"
          >
        </div>
        <a
          class="bot_open mb-3 block w-full text-center"
          href="/counseling/htmlcss-schedule#schedule'"
        >
          <img
            class="te-branded-lp-cta te-btn-hover mx-auto"
            src="~/assets/images/Te/TeLp/Branded/Index/cv-btn.webp"
            alt="無料で相談してみる"
            width="267"
            height="72"
          >
        </a>
        <div class="co-display-14 mt-3 text-center text-co-gray-500">
          ※無理な勧誘は一切ありません
        </div>
      </section>
    </div>
    <TeLpBrandedFixedBtn />
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'
import TeLpBrandedExample from '~/components/Te/TeLp/Branded/Index/TeLpBrandedExample.vue'
import TeLpBrandedReaction from '~/components/Te/TeLp/Branded/Index/TeLpBrandedReaction.vue'  // Add this line
import TeLpBrandedFixedBtn from '~/components/Te/TeLp/Branded/Index/TeLpBrandedFixedBtn.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronRight } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    definePageMeta({
      layout: 'te-simple-lp'
    })
    return {
      faChevronRight
    }
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'indexWithoutZendesk',
    })
    return {
      title:
        '未経験から在宅ワーク・副業・転職。プログラミングスクールならテックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
              'プログラミングの副業、エンジニア転職やキャリアプランについて悩んでいる方へ。未経験の方や初心者の方などが持つ疑問・悩みを解消！現役プログラマーやデザイナーに体験談などを無料で聞ける。',
            twitterTitle:
              '未経験から在宅ワーク・副業・転職。プログラミングスクールならテックアカデミー',
            twitterDescription:
              'プログラミングの副業、エンジニア転職やキャリアプランについて悩んでいる方へ。未経験の方や初心者の方などが持つ疑問・悩みを解消！現役プログラマーやデザイナーに体験談などを無料で聞ける。',
            twitterImage: '/_nuxt/ogp/og-image.jpg',
            ogTitle:
              '未経験から在宅ワーク・副業・転職。プログラミングスクールならテックアカデミー',
            ogDescription:
              'プログラミングの副業、エンジニア転職やキャリアプランについて悩んでいる方へ。未経験の方や初心者の方などが持つ疑問・悩みを解消！現役プログラマーやデザイナーに体験談などを無料で聞ける。',
            ogUrl: '/lp/branded/lp-1',
            ogImage: '/_nuxt/ogp/og-image.jpg',
            noIndexNofollow: true,
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  components: {
    TeLpBrandedExample,
    TeLpBrandedReaction,
    TeLpBrandedFixedBtn,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-lp {
  background-color: #e7f7f6;
}

.te-bg-incentive-header {
  background-color: #2bcbb9;
}

.te-header-incentive-img {
  width: auto;
  @media (min-width: 576px) {
    width: 31.25rem;
    height: 2.5rem;
  }
}

.te-bg-branded-cover {
  background-image: url('~/assets/images/Te/TeLp/Branded/Index/bg-cover.webp');
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
}

.te-branded-catch-img {
  width: auto;
  @media (min-width: 576px) {
    width: 88%;
  }
}

.te-cover-btn {
  width: 16.6875rem;
  height: 4.5rem;
  @media (min-width: 576px) {
    width: 26.25rem;
    height: auto;
  }
}

.te-btn-hover:hover {
  opacity: 0.6;
  transition: all 0.5s ease;
}

.te-cover-caution {
  text-shadow: 0 0 4px #fff;
}

.te-cover-badge-img {
  width: auto;
  @media (min-width: 576px) {
    width: 82%;
  }
}

/* リスキルバナー */
.te-bg-reskill {
  background-color: #aaf0e6;
}

.te-reskill-banner {
  border-radius: 1rem;
}

/* 共通の見出し */
.te-lp-branded-h2-title {
  width: auto;
  @media (min-width: 576px) {
    width: 20rem;
  }
}

/* LPの共通 */
.te-bg-lp-section {
  background-color: #f6ffff;
}

.te-lp-branded-img {
  width: auto;
  @media (min-width: 576px) {
    width: 26.25rem;
  }
}

.te-text-branded {
  color: #0dcab0;
}

/* よくある不安 */
.te-bg-webdesing-aff-anxiety {
  background-color: #f4f6f6;
}

/* 4つの強み */
.te-branded-feature-content {
  margin-top: -2.25rem;
}

/* CTA */
.te-bg-cta {
  background-color: #edfefe;
}

.te-branded-cta-list {
  width: auto;
  @media (min-width: 576px) {
    width: 31.25rem;
    height: 16.8125rem;
  }
}

.te-branded-lp-cta {
  width: 16.6875rem;
  height: 4.5rem;
  @media (min-width: 576px) {
    width: 26.25rem;
    height: auto;
  }
}

/* コース詳細 */
.te-order-cta-ilust {
  width: 3.125rem;
  height: 3.125rem;
  @media (min-width: 576px) {
    width: 6.25rem;
    height: 6.25rem;
  }
}

.te-order-cta-title {
  font-size: 0.75rem;
  @media (min-width: 576px) {
    font-size: 1.125rem;
  }
}

.te-cta-sub-btn {
  font-size: 0.75rem;
  color: #2BCBB9;
  border: 1px solid #2BCBB9;
  border-radius: 4px;
  @media (min-width: 576px) {
    font-size: 1rem;
  }
}

.te-cta-sub-btn:hover {
  background:#eefffd;
  transition: all 0.5s ease;
}

.te-bg-aff-incentive {
  background-color: #fb9e12;
}

</style>
